import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import alertNotificationReducer from "./alertNotificationSlice";
import configReducer from "./configSlice";

const store = configureStore({
  reducer: { 
    auth: authReducer, 
    alertNotification: alertNotificationReducer,
    config: configReducer
  },
});

export default store;
